import _slicedToArray from "/vercel/path0/apps/corona/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/slicedToArray.js";
import _toConsumableArray from "/vercel/path0/apps/corona/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/toConsumableArray.js";
import _asyncToGenerator from "/vercel/path0/apps/corona/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/asyncToGenerator.js";
import _defineProperty from "/vercel/path0/apps/corona/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/defineProperty.js";
import _regeneratorRuntime from "/vercel/path0/apps/corona/node_modules/next/dist/compiled/@babel/runtime/regenerator/index.js";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

import dayjs from 'dayjs';
import { PhoneNumberFormat as PNF, PhoneNumberUtil } from 'google-libphonenumber';
import moment from 'moment';
import * as R from 'ramda';
import { BranchConstants, DAYS_IN_ONE_PERIOD, EMPTY_HTML, ESCAPE_PATTERNS, SOAP_COMMENT_FORMAT, SOAP_TYPES, commonSettings } from '../constants';
import { BILL_STATUS, CATEGORIES, ORDER_STATUS, PRODUCTABLE_TYPE_TO_CHINESE_MAP, SORTED_SUB_ORDER_ITEM_CHINESE, THERAPY_CATEGORY } from '../constants/order';
import { ItemableType, SoapCommentsOldKey, StatusType, _3D_VENDER } from '../types';
import { stripOffsetPayment, sumItemPaymentsAmount } from './order';
import { checkIsDoctorSoap } from './soap';
export * from './chat';
export * from './client';
export * from './diet';
export * from './drug';
export * from './formGenerator';
export * from './misc';
export * from './permission';
export * from './router';
export * from './survey';
export var fullShapeToHalfShape = function fullShapeToHalfShape(str) {
  return str.replace(/[\uff01-\uff5e]/g, function (ch) {
    return String.fromCharCode(ch.charCodeAt(0) - 0xfee0);
  }).replace(/\u3000/g, ' ');
};
export var rangeStep = R.curry(function (start, end, step) {
  return R.unfold(function (n) {
    return n < end ? [n, n + step] : false;
  }, start);
});
export var isNaNOrZeroOrNilOrEmpty = function isNaNOrZeroOrNilOrEmpty(value) {
  return !value || isNaN(value);
};
export var isNilOrNaNOrEmpty = function isNilOrNaNOrEmpty(value) {
  return R.isEmpty(value) || isNaN(value) || R.isNil(value);
};
export var isNilOrEmpty = function isNilOrEmpty(value) {
  return R.isEmpty(value) || R.isNil(value);
};
export var normalizerIdentityNo = function normalizerIdentityNo() {
  var identityNumber = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';

  if (!identityNumber) {
    return '';
  }

  var numbers = [0, 6, 14, 17, 19];

  if (BranchConstants.IS_CHINA_SITE && (identityNumber === null || identityNumber === void 0 ? void 0 : identityNumber.length) === BranchConstants.MAX_IDENTITY_LENGTH) {
    // 123456YYYYMMDD1231 => 123456-YYYYMMDD-123-1
    var chunks = [];

    for (var i = 0; i < numbers.length - 1; i++) {
      var chunk = identityNumber === null || identityNumber === void 0 ? void 0 : identityNumber.slice(numbers[i], numbers[i + 1] || numbers.length);
      chunks.push(chunk);
    }

    return chunks.filter(function (item) {
      return !!item;
    }).join('-');
  }

  return identityNumber;
};
export var toggleListItems = R.curry(function (values, list) {
  return R.reduce(function (acc, cur) {
    return R.ifElse(R.includes(cur), R.without([cur]), R.append(cur))(acc);
  }, list, values);
});
export var generalGetSoapUsers = function generalGetSoapUsers() {
  var soaps = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  var userID = arguments.length > 1 ? arguments[1] : undefined;
  return R.pipe(R.keys, R.chain(function (key) {
    return R.map(R.propOr([], 'user_id'), R.propOr([], key, soaps));
  }), R.append(userID), R.uniq)(SOAP_COMMENT_FORMAT);
};
export var isIncludeMyComments = function isIncludeMyComments(comments, myUserID) {
  return R.any(function (item) {
    return item.user_id === myUserID;
  }, comments);
};
export var getMyLastComment = function getMyLastComment(key, userID) {
  return R.pipe(R.propOr([], key), R.filter(R.propEq(userID, 'user_id')), R.sort(function (a, b) {
    var _b$updated_at;

    return b === null || b === void 0 ? void 0 : (_b$updated_at = b.updated_at) === null || _b$updated_at === void 0 ? void 0 : _b$updated_at.localeCompare(a === null || a === void 0 ? void 0 : a.updated_at);
  }), R.pathOr({
    user_id: userID,
    comment: EMPTY_HTML,
    kind: key
  }, [0]));
};
export var getMySoapCommentsFromRestAPI = function getMySoapCommentsFromRestAPI(data, userID) {
  if (!data) {
    return;
  }

  return R.mapObjIndexed(function (_, key) {
    return getMyLastComment(key, userID)(data);
  }, SOAP_COMMENT_FORMAT);
};
export var getOldFormatCommentsFromRestApiData = R.pick(R.keys(SoapCommentsOldKey));
export var getNewFormatCommentsFromRestApiData = function getNewFormatCommentsFromRestApiData(clinic_soap, users) {
  return R.mapObjIndexed(function (format, key) {
    return R.map(function (item) {
      return _objectSpread(_objectSpread({}, item), {}, {
        user: users.find(function (user) {
          return user.id === item.user_id;
        })
      });
    }, R.propOr([], key, clinic_soap));
  })(SOAP_COMMENT_FORMAT);
};
export var getSoapComments = function getSoapComments(soap) {
  if (!soap) return;
  var _soap$soap_comments = soap.soap_comments,
      soap_comments = _soap$soap_comments === void 0 ? [] : _soap$soap_comments;
  var newFormatComments = R.mapObjIndexed(function (format) {
    return soap_comments === null || soap_comments === void 0 ? void 0 : soap_comments.filter(function (comment) {
      return comment.kind === format.kind && !!comment.comment && comment.comment !== EMPTY_HTML;
    });
  }, SOAP_COMMENT_FORMAT);
  var oldFormatComments = R.pipe(R.omit([SoapCommentsOldKey.dietician_comment]), R.values, R.reduce(function (acc, cur) {
    return _objectSpread(_objectSpread({}, acc), {}, _defineProperty({}, cur.oldKey, soap[cur.oldKey]));
  }, {}))(SOAP_COMMENT_FORMAT);
  return _objectSpread(_objectSpread({}, newFormatComments), oldFormatComments);
};
export var formatToDoDate = function formatToDoDate(dateString, t) {
  var isTheDayBeforeYesterday = dayjs(dateString).isSame(dayjs().subtract(2, 'day'), 'day');
  var isYesterday = dayjs(dateString).isSame(dayjs().subtract(1, 'day'), 'day');
  var isToday = dayjs(dateString).isSame(dayjs(), 'day');
  var date = dayjs(dateString);
  return date.format("".concat(isToday ? t('common:datetime.today', '今天') : isYesterday ? t('common:datetime.yesterday', '昨天') : isTheDayBeforeYesterday ? t('common:datetime.dayBeforeYesterday', '前天') : 'YYYY-MM-DD', " HH:mm:ss"));
};
export var getRandomDate = function getRandomDate(start, end) {
  return new Date(start.getTime() + Math.random() * (end.getTime() - start.getTime()));
};
export var getSoapType = function getSoapType(hasDoctor, type, t) {
  var props = SOAP_TYPES[type];

  if (checkIsDoctorSoap(type)) {
    return props && hasDoctor ? t(props.i18nKey, props.text) : t('common:normal.other', '其他');
  } else {
    return props ? t(props.i18nKey, props.text) : t('common:normal.other', '其他');
  }
};
export var getDataFromPages = R.pipe(R.pathOr([], ['pages']), R.chain(R.pathOr([], ['data', 'data'])));
export var extractRange = function extractRange(data, gender) {
  if ('whitelist' in data) {
    return null;
  }

  if ('male' in data && 'female' in data) {
    return gender && gender in data ? data[gender] : null;
  }

  return {
    gte: 'gte' in data ? data.gte : undefined,
    lte: 'lte' in data ? data.lte : undefined
  };
};
export var getReferenceRangeLabel = function getReferenceRangeLabel(range) {
  var _ref = range !== null && range !== void 0 ? range : {},
      gte = _ref.gte,
      lte = _ref.lte;

  if (R.isNotNil(gte) && R.isNotNil(lte)) {
    return gte + '-' + lte;
  } else if (R.isNotNil(gte) && R.isNil(lte)) {
    return '>' + gte;
  } else if (R.isNil(gte) && R.isNotNil(lte)) {
    return '<' + lte;
  } else {
    return '';
  }
};
export function getMeasurementRefer(data, gender) {
  var range = extractRange(data, gender);

  if (!range) {
    return '';
  }

  return getReferenceRangeLabel(range);
}
export function getRemoteFileBlob(_x) {
  return _getRemoteFileBlob.apply(this, arguments);
}

function _getRemoteFileBlob() {
  _getRemoteFileBlob = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(url) {
    return _regeneratorRuntime.wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            return _context.abrupt("return", new Promise(function (resolve, reject) {
              fetch(url).then(function (response) {
                if (response.status === 200 || response.status === 0) {
                  return resolve(response.blob());
                } else {
                  return reject(new Error(response.statusText));
                }
              });
            }));

          case 1:
          case "end":
            return _context.stop();
        }
      }
    }, _callee);
  }));
  return _getRemoteFileBlob.apply(this, arguments);
}

export function getFilenameFromURL(url) {
  var filename = '';

  try {
    filename = new URL(decodeURI(url)).pathname.split('/').pop();
  } catch (e) {
    console.error(e);
  }

  return decodeURIComponent(filename);
}
export function getValidFilename(name) {
  return name.replace(/[/\\?%*:|"<>]/g, '-').replace(/\s/g, '_');
}
export var getCurrentStepOfTargetWeight = function getCurrentStepOfTargetWeight(_ref2) {
  var isGainWeight = _ref2.isGainWeight,
      percentage = _ref2.percentage,
      weight = _ref2.weight,
      step = _ref2.step;
  return weight * Math.pow((100 + (isGainWeight ? 1 : -1) * percentage) / 100, step);
};
export var getStepArray = function getStepArray(weight, targetPercentage, targetWeight, splitPeriods) {
  var array = [];
  var step = 1;
  var isGainWeight = targetWeight > weight;
  var nextTargetWeight = weight;

  while (isGainWeight ? targetWeight > nextTargetWeight : targetWeight < nextTargetWeight) {
    var daysToAdd = DAYS_IN_ONE_PERIOD / splitPeriods * step;
    nextTargetWeight = getCurrentStepOfTargetWeight({
      isGainWeight: isGainWeight,
      weight: weight,
      percentage: targetPercentage / splitPeriods,
      step: step
    });
    array.push({
      text: nextTargetWeight,
      date: dayjs().add(daysToAdd, 'day').format('YYYY-MM-DD')
    });
    step = step + 1;
  }

  return array;
};
export function getBMI(height, weight) {
  var canCalculate = height > 100 && weight > 29;
  return canCalculate ? (weight / Math.pow(height / 100, 2)).toFixed(2) : '--';
}
export function utcDateString2localDateString(dateString, format) {
  var localDate = utcDateString2localDateObject(dateString);
  return format ? localDate.format(format) : localDate.format();
}
export function utcDateString2localDateObject(dateString) {
  var dateUtc = moment.utc(dateString);
  var localDate = moment(dateUtc).local();
  return localDate;
}
export function sortClientMemosData(a, b) {
  if (!!a.pinned && !b.pinned) {
    return -1;
  }

  if (!a.pinned && !!b.pinned) {
    return 1;
  }

  if (!!a.updated_at && !b.updated_at) {
    return -1;
  }

  return dayjs(b.updated_at).diff(dayjs(a.updated_at));
}
export function blockBubble(e) {
  var _e$nativeEvent;

  e.stopPropagation();
  (_e$nativeEvent = e.nativeEvent) === null || _e$nativeEvent === void 0 ? void 0 : _e$nativeEvent.stopImmediatePropagation();
}
export function normalizePhoneNumber() {
  var phone = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';

  if (!phone) {
    return phone;
  }

  var PhoneNumberUtilInstance = PhoneNumberUtil.getInstance();

  try {
    var parsedNumber = PhoneNumberUtilInstance.parseAndKeepRawInput(phone, 'TW');

    if (PhoneNumberUtilInstance.isValidNumberForRegion(parsedNumber, 'TW')) {
      return PhoneNumberUtilInstance.format(parsedNumber, PNF.NATIONAL);
    }
  } catch (e) {
    // skip
    console.error(e);
  }

  var normalizedPhone = phone.replace(/\+/g, '');

  if (normalizedPhone.startsWith('09')) {
    return normalizedPhone;
  }

  if (normalizedPhone.startsWith('8860')) {
    return normalizedPhone.replace('8860', '0');
  } else if (normalizedPhone.startsWith('886')) {
    return normalizedPhone.replace('886', '0');
  } else if (normalizedPhone.startsWith('86')) {
    return normalizedPhone.replace('86', '');
  }

  return '00' + normalizedPhone;
}
export function normalizePhone() {
  var phone = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';
  return (phone === null || phone === void 0 ? void 0 : phone.replace('+8860', '0').replace('+886', '0')) || '';
}
export function getSearchPhoneString() {
  var phone = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';
  return "%".concat(phone.replace(/^0/, ''), "%");
}
export function getIsCancelledWithoutPayment(state) {
  var bill = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : [];
  return state === ORDER_STATUS.cancelled && !isOrderHasTransactionDetails(bill);
}
export function mapOrderStatus(state, t) {
  var text = t('common:orderStatus.initial', '編輯中');
  var scheme = StatusType.success;

  switch (state) {
    case ORDER_STATUS.initial:
      text = t('order:stepDescriptions.editing', '編輯中');
      scheme = StatusType.success;
      break;

    case ORDER_STATUS.checkout_in_progress:
      text = t('order:stepDescriptions.confirming', '確認中');
      scheme = StatusType.statusBlue;
      break;

    case ORDER_STATUS.payment_in_progress:
      text = t('order:stepDescriptions.checkout', '準備結帳');
      scheme = StatusType.error;
      break;

    case ORDER_STATUS.order_confirmed:
      text = t('order:stepDescriptions.established', '已成立');
      scheme = StatusType.statusGray;
      break;

    case ORDER_STATUS.cancelled:
      text = t('common:orderStatus.voided', '已作廢');
      scheme = StatusType.statusGray;
      break;
  }

  return {
    text: text,
    scheme: scheme
  };
}
export function mapBillStateToScheme(orderState, billDetail, t) {
  var billStatus = t('payment:billNotCreatedYet', '尚未建立帳單');
  var returnStatus = '';
  var scheme = StatusType.statusWhite;

  if (orderState == ORDER_STATUS.order_confirmed) {
    var translatedReturn = t("order:".concat(BILL_STATUS[billDetail].returnStatus));
    billStatus = t("payment:".concat(BILL_STATUS[billDetail].translateKey));

    if (translatedReturn !== '') {
      returnStatus = "(".concat(translatedReturn, ")");
    }

    scheme = BILL_STATUS[billDetail].scheme;
  }

  return {
    text: "".concat(billStatus).concat(returnStatus),
    scheme: scheme
  };
}
export function mapQuestionnaireStatus(value) {
  var text = '未填寫';
  var scheme = StatusType.error;

  switch (value) {
    case 0:
      text = '未填寫';
      scheme = StatusType.error;
      break;

    case 1:
      text = '已填寫';
      scheme = StatusType.success;
      break;
  }

  return {
    text: text,
    scheme: scheme
  };
}
export var FormatMoney = Intl.NumberFormat('en-US', {
  maximumFractionDigits: 0
});
export var FormatSignNumber = function FormatSignNumber() {
  var fraction = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 0;
  return Intl.NumberFormat('en-US', {
    signDisplay: 'exceptZero',
    maximumFractionDigits: fraction
  });
};
/**
 * Creates a new object with the own properties of the provided object, but the
 * keys renamed according to the keysMap object as `{oldKey: newKey}`.
 * When some key is not found in the keysMap, then it's passed as-is.
 *
 * Keep in mind that in the case of keys conflict is behaviour undefined and
 * the result may vary between various JS engines!
 *
 * @sig {a: b} -> {a: *} -> {b: *}
 */

export var renameKeys = R.curry(function (keysMap, obj) {
  return R.reduce(function (acc, key) {
    return R.assoc(keysMap[key] || key, obj[key], acc);
  }, {}, R.keys(obj));
});
export var renameKeysBy = R.curry(function (keysMapFunc, obj) {
  return R.reduce(function (acc, key) {
    return R.assoc(keysMapFunc(key) || key, obj[key], acc);
  }, {}, R.keys(obj));
});
export var pickPaths = function pickPaths(paths, obj) {
  return R.reduce(function (o, p) {
    return R.assocPath(p, R.path(p, obj), o);
  }, {}, paths);
};
export var mergeByKey = function mergeByKey(key) {
  return R.pipe(R.reduceBy(R.mergeDeepRight, {}, R.prop(key)), R.values);
};
export var getUserName = function getUserName(user) {
  return "".concat((user === null || user === void 0 ? void 0 : user.last_name) || '').concat((user === null || user === void 0 ? void 0 : user.first_name) || '');
};
export var getCategoryTranslateKey = function getCategoryTranslateKey(productType) {
  return R.pipe(R.find(R.propEq(productType, 'productable_type')), R.propOr('', 'key'))(CATEGORIES);
};
export var mapTherapyCategory = R.pipe(R.applySpec([R.propOr([], 'order_items'), R.pipe(R.propOr([], 'sub_orders'), R.chain(function (sub_order) {
  return R.pathOr([], ['order_items'], sub_order);
}))]), R.flatten, R.map(R.compose(R.prop(R.__, PRODUCTABLE_TYPE_TO_CHINESE_MAP), R.path(['products', 'productable_type']))), R.uniq, R.reject(R.isNil), R.sort(function (a, b) {
  return SORTED_SUB_ORDER_ITEM_CHINESE.indexOf(a) - SORTED_SUB_ORDER_ITEM_CHINESE.indexOf(b);
}));
export var getTotalRefundedAmount = R.pipe(R.chain(R.propOr([], 'transaction_details')), R.map(R.propOr(0, 'amount')), R.filter(function (item) {
  return item < 0;
}), R.sum, R.defaultTo(0));
export var getTotalReceivedAmount = R.pipe(R.chain(R.propOr([], 'transaction_details')), R.map(R.propOr(0, 'amount')), R.filter(function (item) {
  return item > 0;
}), R.sum, R.defaultTo(0));
export var getSalesAllowancesFromOrder = R.pathOr([], ['bills', 0, 'sales_allowances']);
export var getTotalDiscountAmount = R.pipe(R.map(R.propOr(0, 'total_amount')), R.sum, R.defaultTo(0));
export var getTotalAmountToDiscount = R.pipe(R.map(R.propOr(0, 'amount_to_discount')), R.sum, R.defaultTo(0));
export var getTotalAmountFromItems = R.pipe(R.map(R.propOr(0, 'amount')), R.sum, R.defaultTo(0));
export var getTotalQuantityFromItems = R.pipe(R.map(R.propOr(0, 'quantity')), R.sum, R.defaultTo(0));
export var getFirstTherapyFromOrder = R.pipe(R.applySpec([R.propOr([], 'order_items'), R.pipe(R.propOr([], 'sub_orders'), R.chain(function (sub_order) {
  return R.pathOr([], ['order_items'], sub_order);
}))]), R.flatten, R.filter(function (item) {
  return !!item && !item.parent_id && R.path(['products', 'productable_type'], item) === THERAPY_CATEGORY.productable_type;
}), R.map(function (item) {
  return item.product_name || '';
}), R.head);
export var getSubTotalFromOrderItems = R.pipe(R.filter(R.compose(R.complement(Boolean), R.prop('_destroy'))), R.map(R.propOr(0, 'discounted_amount')), R.sum, R.defaultTo(0));
export var getDiscountTotalFromOrderItems = R.pipe(R.filter(R.compose(R.complement(Boolean), R.prop('_destroy'))), R.map(R.propOr(0, 'discount_amount')), R.sum, R.defaultTo(0));
export var getAllowanceTotalFromOrderItems = R.pipe(R.filter(R.compose(R.complement(Boolean), R.prop('_destroy'))), R.map(R.propOr(0, 'allowance_amount')), R.sum, R.defaultTo(0));
export var getSubTotalFromTransactionDetails = getTotalAmountFromItems;
export var getTotalAmountFromOrderPayments = R.pipe(R.values, R.filter(R.propEq(true, '_active')), R.chain(R.prop('amount')), R.sum, R.defaultTo(0));
export var transformOrderForDisplay = function transformOrderForDisplay(order) {
  return R.pipe(R.pathOr([], ['order_items']), R.map(function (item) {
    return _objectSpread(_objectSpread({}, item), {}, {
      category: R.path(['products', 'product_with_productable', 'category'], item),
      productable_type: R.path(['products', 'productable_type'], item),
      list_price: R.path(['products', 'list_price'], item),
      user_id: R.prop('user_id', order),
      user_name: getUserName(order.user),
      metadata: R.path(['data', 'metadata'], item),
      _disabled: false
    });
  }))(order);
};
export var mergeSalesAllowances = function mergeSalesAllowances(salesAllowances) {
  return R.pipe(R.map(R.assoc('description', '')), R.map(R.assoc('amount_to_discount', 0)), R.map(R.assoc('quantity_to_discount', 0)), R.map(function (item) {
    var targetSalesAllowances = R.filter(R.propEq(item._id, '_id'))(salesAllowances);
    return _objectSpread(_objectSpread({}, item), {}, {
      allowance_amount: getTotalAmountFromItems(targetSalesAllowances),
      allowance_quantity: getTotalQuantityFromItems(targetSalesAllowances)
    });
  }), R.map(function (item) {
    return R.assoc('_disable', R.equals(R.prop('allowance_amount', item), R.prop('discounted_amount', item)), item);
  }));
};
export var transformSalesAllowances = R.pipe(R.chain(R.prop('items')), R.groupBy(R.prop('_id')), R.mapObjIndexed(function (items, key) {
  return {
    amount: getTotalAmountFromItems(items),
    quantity: getTotalQuantityFromItems(items),
    _id: Number(key)
  };
}), R.values);
export var transformSubOrderForDisplay = function transformSubOrderForDisplay(isAdmin, currentUserId, salesList) {
  var isOffset = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : false;
  return R.pipe(R.path(['sub_orders']), R.chain(function (sub_order) {
    return sub_order.order_items.reduce(function (a, item) {
      if (item.quantity < 0 && !isOffset || item.quantity >= 0 && isOffset) return a;
      var salesAccount = R.pipe(R.defaultTo([]), R.find(R.propEq(item.user_id, 'id')))(salesList);
      return [].concat(_toConsumableArray(a), [_objectSpread(_objectSpread({}, item), {}, {
        category: R.path(['products', 'product_with_productable', 'category'], item),
        productable_type: R.path(['products', 'productable_type'], item),
        list_price: R.path(['products', 'list_price'], item),
        user_id: salesAccount === null || salesAccount === void 0 ? void 0 : salesAccount.id,
        user_name: getUserName(salesAccount),
        creator_name: getUserName(sub_order.user),
        metadata: R.path(['data', 'metadata'])(item),
        sub_items: R.pipe(R.pathOr([], ['sub_items']), R.map(function (_item) {
          return _objectSpread(_objectSpread({}, _item), {}, {
            category: R.path(['products', 'product_with_productable', 'category'], _item),
            productable_type: R.path(['products', 'productable_type'], _item),
            list_price: R.path(['products', 'list_price'], _item)
          });
        }))(item),
        _disabled: !isAdmin && currentUserId != sub_order.user_id
      })]);
    }, []);
  }));
};
export var transformMedicationOrderForDisplay = function transformMedicationOrderForDisplay(order) {
  var _order$itemable;

  var identifier = R.pathOr({}, ['itemable', 'identifier'])(order);
  var itemableType = R.pathOr('', ['itemable', 'type'])(order);
  var product = itemableType === ItemableType['Pharmacy::Medicine'] ? R.path(['itemable', 'identifier', 'products', 0])(order) : R.path(['itemable', 'product'])(order);
  var subtotal = ((product === null || product === void 0 ? void 0 : product.price) || 0) * (Number(order === null || order === void 0 ? void 0 : order.medicine_amount) || 0);
  return {
    metadata: {
      snapshot: R.mergeLeft(_objectSpread(_objectSpread(_objectSpread({}, Object(R.pickAll(['package_amount', 'package_unit', 'minimum_unit', 'usage'])(identifier))), R.pick(['chinese_name', 'english_name', 'serial_code', 'category'])(order.itemable)), {}, {
        branch_id: order.itemable.branch_id,
        medicine_amount: order.medicine_amount,
        total_amount: order.total_amount,
        compliance: order.compliance,
        days: order.days,
        single_amount: order.single_amount,
        frequency: order.frequency,
        frequency_ratio: order.frequency_ratio
      }))(product || {})
    },
    subtotal: subtotal,
    discount_amount: 0,
    discounted_amount: subtotal,
    quantity: (order === null || order === void 0 ? void 0 : order.medicine_amount) || 0,
    price: (product === null || product === void 0 ? void 0 : product.price) || 0,
    unit: product === null || product === void 0 ? void 0 : product.unit,
    product_id: product === null || product === void 0 ? void 0 : product.id,
    productable_type: product === null || product === void 0 ? void 0 : product.productable_type,
    category: order === null || order === void 0 ? void 0 : (_order$itemable = order.itemable) === null || _order$itemable === void 0 ? void 0 : _order$itemable.category,
    _disabled: false
  };
};
export var getTransactionSummary = function getTransactionSummary(state, bill) {
  var _ref3 = bill || {},
      _ref3$sales_allowance = _ref3.sales_allowances,
      sales_allowances = _ref3$sales_allowance === void 0 ? [] : _ref3$sales_allowance,
      _ref3$payments = _ref3.payments,
      billPayments = _ref3$payments === void 0 ? [] : _ref3$payments,
      _ref3$total_amount = _ref3.total_amount,
      total_amount = _ref3$total_amount === void 0 ? 0 : _ref3$total_amount;

  var totalDiscount = getTotalDiscountAmount(sales_allowances);
  var payments = stripOffsetPayment(billPayments);
  var refundedAmount = getTotalRefundedAmount(payments);
  var receivedAmount = getTotalReceivedAmount(payments);
  var orderReturnAmount = R.path(['sales_returns', 0, 'total_amount'], bill); // we allow orderReturnAmount as 0, and use orderReturnAmount as enabled/disabled sales_returns flag

  var totalExpectedReceipts = total_amount - totalDiscount - (orderReturnAmount !== null && orderReturnAmount !== void 0 ? orderReturnAmount : 0);
  var remainingAmount = totalExpectedReceipts - receivedAmount - refundedAmount;
  return {
    billReceivable: total_amount,
    receivedAmount: receivedAmount,
    refundedAmount: refundedAmount,
    totalDiscount: totalDiscount,
    orderReturnAmount: orderReturnAmount,
    totalExpectedReceipts: totalExpectedReceipts,
    remainingAmount: remainingAmount,
    isOrderBillFulfilled: state >= ORDER_STATUS.order_confirmed && remainingAmount === 0
  };
};
export var validateOrderTransactionAmount = function validateOrderTransactionAmount(_ref4) {
  var t = _ref4.t,
      orderForm = _ref4.orderForm,
      transaction_type = _ref4.transaction_type;

  var _getTransactionSummar = getTransactionSummary(orderForm.state, orderForm.bill),
      receivedAmount = _getTransactionSummar.receivedAmount,
      refundedAmount = _getTransactionSummar.refundedAmount,
      remainingAmount = _getTransactionSummar.remainingAmount;

  var totalPaymentAmount = Number(R.compose(getTotalAmountFromOrderPayments, R.path(['payment', 'methods']))(orderForm));
  var totalExpectedAmount = sumItemPaymentsAmount(R.path(['payment', 'item_payments'], orderForm));

  if (totalPaymentAmount !== totalExpectedAmount) {
    return t('payment:validation.expectedShouldEqualReal', '『實際交易總金額』必須等於『本期預計交易總金額』');
  }

  switch (transaction_type) {
    case commonSettings.TRANSACTION_TYPE.refund.key:
      if (remainingAmount > 0 && totalPaymentAmount + receivedAmount + refundedAmount < 0 || remainingAmount < 0 && totalPaymentAmount < remainingAmount) {
        return t('order:refundAmountExceedsTotalAmount', '退款金額不可超過(已收金額 - 已退金額)');
      }

      break;

    case commonSettings.TRANSACTION_TYPE.payment.key:
      if (totalPaymentAmount > remainingAmount) {
        return t('order:paidAmountExceedsTotalAmount', '收款金額不可超過待結金額');
      }

      break;
  }
};
export var isOrderHasTransactionDetails = R.pipe(R.propOr([], 'payments'), R.chain(R.pathOr([], ['transaction_details'])), R.complement(R.isEmpty));
export var getTransactionDetailsAttributes = function getTransactionDetailsAttributes(data) {
  return R.pipe(function (orderData) {
    return R.pathOr({}, ['payment', 'methods'], orderData);
  }, R.filter(R.propEq(true, '_active')), R.mapObjIndexed(function (item, key) {
    var _data$payment;

    return {
      amount: +item.amount,
      description: item.note,
      branch_payment_method_id: key,
      date_time: ((_data$payment = data.payment) === null || _data$payment === void 0 ? void 0 : _data$payment.date_time) || dayjs().format('YYYY-MM-DD')
    };
  }), R.values)(data);
};
export var extractObjectsWithKey = R.curry(function (keyToCheck, obj) {
  if (R.is(Object, obj)) {
    return Object.entries(obj).flatMap(function (_ref5) {
      var _ref6 = _slicedToArray(_ref5, 2),
          key = _ref6[0],
          value = _ref6[1];

      return key === keyToCheck ? [obj] : extractObjectsWithKey(keyToCheck, value);
    });
  } else {
    return [];
  }
});
export var toNegative = function toNegative(value) {
  var numberValue = Number(value);
  var absoluteValue = Math.abs(numberValue);
  return isNaN(numberValue) ? 0 : -1 * absoluteValue;
};
export var mapSelectedFromRowSelectionState = function mapSelectedFromRowSelectionState(rowSelectionState, list) {
  return R.props(R.keys(rowSelectionState), list);
};
export var map3DPointsData = function map3DPointsData(item, originalData) {
  var keys = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : [];
  var type = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : _3D_VENDER.tg3d;
  var pointsData = R.pipe(R.keys, R.filter(function (key) {
    return (keys === null || keys === void 0 ? void 0 : keys.includes(key)) && !!originalData[key];
  }), R.map(function (key) {
    return {
      key: key,
      points: type === _3D_VENDER.visbody ? R.pipe(R.pathOr({}, ['pointList']), R.values)(originalData[key]) : R.path(['origin', 'line_points'], originalData[key]),
      value: R.path(type === _3D_VENDER.visbody ? ['value'] : ['origin', 'value'], originalData[key])
    };
  }))(originalData);
  var data = R.pipe(R.map(R.path(type === _3D_VENDER.visbody ? ['value'] : ['origin', 'value'])), R.when(function () {
    return type === _3D_VENDER.visbody;
  }, R.map(function (value) {
    return !isNaN(Number(value)) ? Number(value) / 10 : value;
  })), R.map(function (value) {
    return Number.parseFloat(value).toFixed(2);
  }))(originalData);
  return _objectSpread(_objectSpread({}, item), {}, {
    data: data,
    pointsData: pointsData
  });
};
export var mapMeasurementData = function mapMeasurementData(item, jsonData) {
  var keys = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
  var oldFormatData = R.pipe(R.propOr({}, 'data'), R.map(function (value) {
    return Number.parseFloat(value).toFixed(2);
  }))(item);
  var isOldFormat = R.pipe(R.propOr([], 'upload_files'), R.filter(R.propEq('measurement_data', 'data_type')), R.isEmpty)(item);

  if (isOldFormat) {
    return _objectSpread(_objectSpread({}, item), {}, {
      data: oldFormatData,
      pointsData: []
    });
  }

  var measurement = jsonData === null || jsonData === void 0 ? void 0 : jsonData.find(function (data) {
    return data.id === item.id;
  });
  var brand = item === null || item === void 0 ? void 0 : item.equip_brand;
  return map3DPointsData(item, (measurement === null || measurement === void 0 ? void 0 : measurement.data) || {}, keys[brand], brand);
};
export var getBirthdayDayOptions = function getBirthdayDayOptions() {
  return Array.from({
    length: 31
  }, function (_, i) {
    var day = i + 1;
    return {
      label: "".concat(day, " \u65E5"),
      value: day
    };
  });
};
export var getBirthdayMonthOptions = function getBirthdayMonthOptions() {
  return Array.from({
    length: 12
  }, function (_, i) {
    var month = i + 1;
    return {
      label: "".concat(month, " \u6708"),
      value: month
    };
  });
};
var currentYear = new Date().getFullYear();
export var getBirthdayYearOptions = function getBirthdayYearOptions() {
  return Array.from({
    length: currentYear - 1911
  }, function (_, i) {
    var year = currentYear - i;
    return {
      label: "".concat(year, " / \u6C11\u570B ").concat(year - 1911, "\u5E74"),
      value: year
    };
  });
};
export var escapeSQLChars = function escapeSQLChars(text) {
  return ESCAPE_PATTERNS.reduce(function (escapedText, _ref7) {
    var _ref8 = _slicedToArray(_ref7, 2),
        pattern = _ref8[0],
        replacement = _ref8[1];

    return escapedText.replace(pattern, replacement);
  }, text);
};
export function formatRangeText(from, to) {
  if (R.isNil(from) || R.isNil(to)) {
    return 'N/A';
  }

  return "".concat(from, " \uFF5E ").concat(to);
}